var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterWavaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.54,
    height: 33.54,
    rx: 16.77,
    transform: "matrix(-1 0 0 1 33.54 0)",
    fill: "#191A1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6682 12.6111L25.1801 12.6111L25.1801 9.25705L28.6682 9.25705L28.6682 12.6111Z",
    fill: "#E1E4E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8462 24.8438L26.0688 24.8437L15.0404 9.21009L19.28 9.2101L28.8462 24.8438Z",
    fill: "#E1E4E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0466 24.7718L15.2693 24.7718L4.02494 9.3246L8.17185 9.32459L18.0466 24.7718Z",
    fill: "#E1E4E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWavaIcon);
export default __webpack_public_path__ + "static/media/footer_wava_icon.a199e4ea293a7e3ffc2a7234faadfa63.svg";
export { ForwardRef as ReactComponent };